/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  $("#wp-submit").addClass("btn btn-orange");
});
